import axios from '../axios';
import { endPoints } from '../endpoints';
import {
  GetAnalyticsInvoicesListParams,
  GetAnalyticsInvoicesListResponse,
  GetAnalyticsTimesheetListParams,
  GetAnalyticsTimesheetListResponse,
  GetAnalyticsPensionDocumentListParams,
  GetAnalyticsPensionDocumentListResponse,
  GetAnalyticsPayrollCostListParams,
  GetAnalyticsPayrollCostListResponse,
  GetAnalyticsPaymentsListParams,
  GetAnalyticsPaymentsListResponse,
  GetAnalyticsPaymentsTaxPeriodResponse,
  GetAnalyticsEmployeeStatusResponse,
  GetAnalyticsRequiredAlertsListParams,
  GetAnalyticsRequiredAlertsListResponse,
  GetAnalyticsRegistrationListParams,
  GetAnalyticsRegistrationListResponse,
  GetAnalyticsPayslipsProcessedListParams,
  GetAnalyticsPayslipsProcessedListResponse,
  GetAnalyticsActivePayrollRunParams,
  GetAnalyticsActivePayrollRunResponse,
  PayrollRunTasksUpdateItem,
  PostAnalyticsPayrollRunTasksResponse,
} from '@nxsys/types/api/analytics';

export const getAnalyticsPayrollCostList = async (
  params: GetAnalyticsPayrollCostListParams,
): Promise<GetAnalyticsPayrollCostListResponse> => {
  const response = await axios.get(endPoints.analytics.payrollCostList, {
    params,
  });
  return response.data;
};

export const getAnalyticsPaymentsList = async (
  params: GetAnalyticsPaymentsListParams,
): Promise<GetAnalyticsPaymentsListResponse> => {
  const response = await axios.get(endPoints.analytics.paymentsList, {
    params,
  });
  return response.data;
};

export const getAnalyticsPaymentsTaxPeriod = async (
  params?: GetAnalyticsPayslipsProcessedListParams,
): Promise<GetAnalyticsPaymentsTaxPeriodResponse> => {
  const response = await axios.get(endPoints.analytics.paymentsTaxPeriod, {
    params,
  });
  return response.data;
};

export const getAnalyticsEmployeeStatus = async (
  params?: GetAnalyticsPayslipsProcessedListParams,
): Promise<GetAnalyticsEmployeeStatusResponse> => {
  const response = await axios.get(endPoints.analytics.employeeStatus, {
    params,
  });
  return response.data;
};

export const getAnalyticsPensionDocumentList = async (
  params: GetAnalyticsPensionDocumentListParams,
): Promise<GetAnalyticsPensionDocumentListResponse> => {
  const response = await axios.get(endPoints.analytics.pensionDocumentList, {
    params,
  });
  return response.data;
};

export const getAnalyticsTimesheetReceivedList = async (
  params: GetAnalyticsTimesheetListParams,
): Promise<GetAnalyticsTimesheetListResponse> => {
  const response = await axios.get(endPoints.timesheet.main, { params });
  return response.data;
};

export const getAnalyticsInvoicesList = async (
  params: GetAnalyticsInvoicesListParams,
): Promise<GetAnalyticsInvoicesListResponse> => {
  const response = await axios.get(endPoints.analytics.invoicingValuesList, { params });
  return response.data;
};

export const getAnalyticsRequiredAlertsList = async (
  params: GetAnalyticsRequiredAlertsListParams,
): Promise<GetAnalyticsRequiredAlertsListResponse> => {
  const response = await axios.get(endPoints.analytics.requiredAlertsList, {
    params,
  });
  return response.data;
};

export const getAnalyticsRegistrationList = async (
  params: GetAnalyticsRegistrationListParams,
): Promise<GetAnalyticsRegistrationListResponse> => {
  const response = await axios.get(endPoints.analytics.registrationList, {
    params,
  });
  return response.data;
};

export const getAnalyticsPayslipsProcessedList = async (
  params: GetAnalyticsPayslipsProcessedListParams,
): Promise<GetAnalyticsPayslipsProcessedListResponse> => {
  const response = await axios.get(endPoints.analytics.payslipsProcessedList, {
    params,
  });
  return response.data;
};

export const getAnalyticsActivePayrollRunList = async (
  params: GetAnalyticsActivePayrollRunParams,
): Promise<GetAnalyticsActivePayrollRunResponse> => {
  const response = await axios.get(endPoints.analytics.activePayrollRun, {
    params,
  });
  return response.data;
};

export const postAnalyticsPayrollRunTasks = async (
  payload: PayrollRunTasksUpdateItem[],
): Promise<PostAnalyticsPayrollRunTasksResponse> => {
  const response = await axios.post(
    endPoints.analytics.payrollRunTasks,
    payload,
  );
  return response.data;
};
